export default __webpack_public_path__ + "static/media/job_offer6_s.ee671c1a.jpg";